// Message shown under a form field; referenced by the field's aria-describedby.
export const FieldError = ({ id, message }) =>
    message ? (
        <p id={`${id}-error`} className="text-sm text-destructive-text">
            {message}
        </p>
    ) : null;
